import styled from "styled-components"
import {standardFontSize} from "../../assets/values/fontSizes/standardFontSize"

export const SubTitle = styled.h3`
    
    font-size: ${standardFontSize.subTitle};
    color: ${({theme}) => theme.colors.title};
    z-index: 1;
    
`